import {
  ImageList,
  ImageListItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import moment from 'moment';
import React from 'react';

function PlacementDetailSection({ placementSlipData, installmentDetails, type = '',policyDetail=null }) {
  const isImageFile = (url = "") => {
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "webp"];
    const ext = url.split(".").pop()?.toLowerCase();
    return imageExtensions.includes(ext);
  };

  const getImageFilePreview = (fileUrl = "") => {
    if (!fileUrl) {
      return "https://p.kindpng.com/picc/s/160-1608792_circle-document-icon-png-transparent-png.png";
    }

    return isImageFile(fileUrl)
      ? `${fileUrl}?w=164&h=2000&objectFit=contain`
      : "https://p.kindpng.com/picc/s/160-1608792_circle-document-icon-png-transparent-png.png";
  };

  return (
    <div style={{ marginTop: '5px' }}>
      <div>
        <Typography
          gutterBottom
          variant="h4"
          className="blockHeader heading"
          component="div"
          style={{
            background: 'rgb(9 84 174)',
            color: '#fff',
            padding: '16px',
            paddingTop: '2px',
            paddingBottom: '2px',
            marginBottom: '3vh'
          }}
        >
          <div
            style={{
              paddingTop: '0.3%',
              paddingBottom: '0.3%'
            }}
          >
            {type != 'qc' ? 'Placement Details' : 'Co Insurance Details'}
          </div>
        </Typography>
      </div>

      <Table aria-label="a dense table" style={{ width: '100%' }}>
        <TableBody
          style={{
            opacity:
              (
                policyDetail?.parentqcData ||
                policyDetail?.insurancePolicy?.qcData
              )?.co_insurance_details?.status === 'approve'
                ? 0.5
                : 1,
            pointerEvents:
              (
                policyDetail?.parentqcData ||
                policyDetail?.insurancePolicy?.qcData
              )?.co_insurance_details?.status === 'approve'
                ? 'none'
                : 'auto',
            marginBottom: '10px'
          }}
        >
          {type != 'qc' && <>
            <TableRow>
              <TableCell
                style={{
                  height: '20px',
                  paddingTop: '2px',
                  paddingBottom: '2px',
                  paddingLeft: '0px'
                }}
              >
                Agreed Brokerage Rate (%) *
              </TableCell>
              <TableCell
                style={{
                  height: '20px',
                  paddingTop: '2px',
                  paddingBottom: '2px',
                  paddingLeft: '0px',
                  textAlign: 'right'
                }}
              >
                {' '}
                {placementSlipData[0]?.agreedBrokerageRate
                  ? placementSlipData[0].agreedBrokerageRate
                  : 'N/A'}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell
                style={{
                  height: '20px',
                  paddingTop: '2px',
                  paddingBottom: '2px',
                  paddingLeft: '0px',

                }}
              >
                Payment Frequency
              </TableCell>
              <TableCell
                style={{
                  height: '20px',
                  paddingTop: '2px',
                  paddingBottom: '2px',
                  paddingLeft: '0px',
                  textAlign: 'right'
                }}
              >
                {' '}
                {placementSlipData[0]?.paymentFrequency
                  ? placementSlipData[0].paymentFrequency
                  : 'N/A'}
              </TableCell>
            </TableRow>
          </>}

          <TableRow>
            <TableCell
              style={{
                height: '20px',
                paddingTop: '2px',
                paddingBottom: '2px',
                paddingLeft: '0px'
              }}
            >
              Is Co Insurance Applicable
            </TableCell>

            <TableCell
              style={{
                height: '20px',
                paddingTop: '2px',
                paddingBottom: '2px',
                paddingLeft: '0px',
                textAlign: 'right'
              }}
            >
              {placementSlipData[0]?.coInsuranceApplicable ? 'Yes' : 'No'}
            </TableCell>
          </TableRow>

          {type != 'qc' && <><TableRow>
            <TableCell
              style={{
                height: '20px',
                paddingTop: '2px',
                paddingBottom: '2px',
                paddingLeft: '0px'
              }}
            >
              Brokerage Paid By
            </TableCell>

            <TableCell
              style={{
                height: '20px',
                paddingTop: '2px',
                paddingBottom: '2px',
                paddingLeft: '0px',
                textAlign: 'right'
              }}
            >
              {placementSlipData[0]?.brokeragePaidby ?? 'N/A'}
            </TableCell>
          </TableRow>

            <TableRow>
              <TableCell
                style={{
                  height: '20px',
                  paddingTop: '2px',
                  paddingBottom: '2px',
                  paddingLeft: '0px'
                }}
              >
                Payment Slip
              </TableCell>

              <TableCell
                style={{
                  height: '20px',
                  paddingTop: '2px',
                  paddingBottom: '2px',
                  paddingLeft: '0px',
                  textAlign: 'right'
                }}
              >
                {placementSlipData[0]?.paymentSlip ? (
                  <ImageList>
                    <ImageListItem sx={{ cursor: 'pointer' }}>
                      {isImageFile(placementSlipData[0]?.paymentSlip) ? (
                        <img
                          className="previewImg"
                          src={getImageFilePreview(placementSlipData[0]?.paymentSlip)}
                          alt="preview"
                          loading="lazy"
                          onClick={() => window.open(placementSlipData[0]?.paymentSlip, '_blank')}
                        />
                      ) : (
                        <img
                          className="previewImg"
                          src="https://p.kindpng.com/picc/s/160-1608792_circle-document-icon-png-transparent-png.png"
                          alt="document"
                          onClick={() => window.open(placementSlipData[0]?.paymentSlip, '_blank')}
                        />
                      )}
                    </ImageListItem>
                  </ImageList>
                ) : (
                  <p className="text-center">N/A</p>
                )}

              </TableCell>
            </TableRow></>}



          {/* <TableRow>
            <TableCell
              style={{
                height: '20px',
                paddingTop: '2px',
                paddingBottom: '2px',
                paddingLeft: '0px'
              }}
            >
              Date Of Payment
            </TableCell>
            <TableCell
              style={{
                height: '20px',
                paddingTop: '2px',
                paddingBottom: '2px',
                paddingLeft: '0px'
              }}
            >
              {placementSlipData[0]?.dateOfPayment
                ? moment(placementSlipData[0].dateOfPayment).format(
                    'DD-MM-yyyy'
                  )
                : 'N/A'}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              style={{
                height: '20px',
                paddingTop: '2px',
                paddingBottom: '2px',
                paddingLeft: '0px'
              }}
            >
              From Date
            </TableCell>
            <TableCell
              style={{
                height: '20px',
                paddingTop: '2px',
                paddingBottom: '2px',
                paddingLeft: '0px'
              }}
            >
              {' '}
              {placementSlipData[0]?.policyStartDate
                ? moment(placementSlipData[0].policyStartDate).format(
                    'DD-MM-yyyy'
                  )
                : 'N/A'}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              style={{
                height: '20px',
                paddingTop: '2px',
                paddingBottom: '2px',
                paddingLeft: '0px'
              }}
            >
              To Date
            </TableCell>
            <TableCell
              style={{
                height: '20px',
                paddingTop: '2px',
                paddingBottom: '2px',
                paddingLeft: '0px'
              }}
            >
              {' '}
              {placementSlipData[0]?.policyEndDate
                ? moment(placementSlipData[0].policyEndDate).format(
                    'DD-MM-yyyy'
                  )
                : 'N/A'}
            </TableCell>
          </TableRow> */}
        </TableBody>
      </Table>
      {/* <Typography variant="h5">Installment Details</Typography>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead style={{ background: 'rgba(187, 220, 214, 0.32)' }}>
          <TableRow>
            <TableCell
              style={{
                height: '20px',
                paddingTop: '2px',
                paddingBottom: '2px'
              }}
            >
              Installments
            </TableCell>
            <TableCell
              style={{
                height: '20px',
                paddingTop: '2px',
                paddingBottom: '2px'
              }}
            >
              Amount To Be Paid
            </TableCell>
            <TableCell
              style={{
                height: '20px',
                paddingTop: '2px',
                paddingBottom: '2px'
              }}
            >
              Due Date
            </TableCell>
            <TableCell
              style={{
                height: '20px',
                paddingTop: '2px',
                paddingBottom: '2px'
              }}
            >
              Bank Name
            </TableCell>
            <TableCell
              style={{
                height: '20px',
                paddingTop: '2px',
                paddingBottom: '2px'
              }}
            >
              Bank Branch
            </TableCell>
            <TableCell
              style={{
                height: '20px',
                paddingTop: '2px',
                paddingBottom: '2px'
              }}
            >
              Payment Type
            </TableCell>
            <TableCell
              style={{
                height: '20px',
                paddingTop: '2px',
                paddingBottom: '2px'
              }}
            >
              Payment Reference No
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {installmentDetails?.map((installment) => {
            return (
              <>
                <TableRow>
                  <TableCell
                    style={{
                      height: '20px',
                      paddingTop: '2px',
                      paddingBottom: '2px'
                    }}
                  >
                    {installment.installments
                      ? installment.installments
                      : 'N/A'}
                  </TableCell>
                  <TableCell
                    style={{
                      height: '20px',
                      paddingTop: '2px',
                      paddingBottom: '2px'
                    }}
                  >
                    {installment.amountToBePaid
                      ? installment.amountToBePaid
                      : 'N/A'}
                  </TableCell>
                  <TableCell
                    style={{
                      height: '20px',
                      paddingTop: '2px',
                      paddingBottom: '2px'
                    }}
                  >
                    {installment.dueDate
                      ? moment(installment.dueDate).format('DD-MM-yyyy')
                      : 'N/A'}
                  </TableCell>
                  <TableCell
                    style={{
                      height: '20px',
                      paddingTop: '2px',
                      paddingBottom: '2px'
                    }}
                  >
                    {installment.bankName ? installment.bankName : 'N/A'}
                  </TableCell>
                  <TableCell
                    style={{
                      height: '20px',
                      paddingTop: '2px',
                      paddingBottom: '2px'
                    }}
                  >
                    {installment.bankBranch ? installment.bankBranch : 'N/A'}
                  </TableCell>
                  <TableCell
                    style={{
                      height: '20px',
                      paddingTop: '2px',
                      paddingBottom: '2px'
                    }}
                  >
                    {installment.paymentType ? installment.paymentType : 'N/A'}
                  </TableCell>
                  <TableCell
                    style={{
                      height: '20px',
                      paddingTop: '2px',
                      paddingBottom: '2px'
                    }}
                  >
                    {installment.paymentReferenceNo
                      ? installment.paymentReferenceNo
                      : 'N/A'}
                  </TableCell>
                </TableRow>
              </>
            );
          })}
        </TableBody>
      </Table> */}
    </div>
  );
}

export default PlacementDetailSection;
